/**
 * DADOS DO ESCRITÓRIO — edite apenas este arquivo para personalizar o site.
 * Troque nome, OAB, número do WhatsApp (formato internacional: 55 + DDD + número),
 * foto e contato. Nada mais precisa ser alterado.
 */
export const OFFICE = {
  name: "AMN Advogadas Associadas",
  shortName: "AMN Advogadas",
  lawyer: "AMN Advogadas",
  role: "Consultoria Jurídica · Campestre/MG",
  oab: "OAB/MG 213.499 · 198.660 · 233.902",
  mainArea: "Direito Previdenciário",
  whatsapp: "5535999235351", // atendimento comercial — somente WhatsApp
  photo:
    "https://images.pexels.com/photos/6077091/pexels-photo-6077091.jpeg?auto=compress&cs=tinysrgb&w=1200",
  city: "Campestre · MG",
  email: "anmadvogadasassociadas@gmail.com",
  phone: "5535999941301", // número para ligação (55 + DDD + número)
  phonePretty: "(35) 99994-1301",
  whatsappPretty: "(35) 99923-5351",
  address: "Av. José André Avelino, 564 — Centro, Campestre/MG",
  hours: "Seg. a Sex., das 8h30 às 11h30 e das 13h às 18h",
  instagram: "https://www.instagram.com/anmadvogadas",
  // Cole aqui o link da página do Facebook (ex.: "https://www.facebook.com/anmadvogadas").
  // Enquanto estiver vazio, o ícone do Facebook não aparece.
  facebook: "",
};

export const LOCATIONS = [
  {
    label: "Unidade 1",
    city: "Campestre · MG",
    address: "Avenida José André Avelino, 564 — Campestre/MG",
    query: "Avenida José André Avelino, 564, Campestre, MG",
  },
  {
    label: "Unidade 2",
    city: "Poços de Caldas · MG",
    address: "Rua Wanda Tramonte Quinteiro, 56 — Primavera, Poços de Caldas/MG",
    query: "Rua Wanda Tramonte Quinteiro, 56, Primavera, Poços de Caldas, MG",
  },
];

export const mapsLink = (q) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

// Abre a janela de triagem de qualquer lugar do site.
// Ex.: openTriage() → escolhe o assunto; openTriage({ title: "BPC / LOAS", area: "previdenciario" })
export const openTriage = (detail = {}) =>
  window.dispatchEvent(new CustomEvent("open-triage", { detail }));

export const waMessage = (solution) =>
  solution
    ? `Olá, gostaria de agendar uma consulta sobre ${solution}.`
    : "Olá, gostaria de agendar uma consulta jurídica.";

// Remove os caracteres de formatação do WhatsApp das respostas digitadas pelo cliente
const clean = (t) => String(t).replace(/[*_~`]/g, "").trim();

// Protocolo: AMN-DDMM-HHMM-FINAL (dia, mês, hora e minuto do envio)
// FINAL = 4 últimos números do telefone; sem telefone, o primeiro nome (sem acentos);
// sem nenhum dos dois, 4 números sorteados.
export const makeProtocol = ({ name = "", phone = "" } = {}, d = new Date()) => {
  const p = (n) => String(n).padStart(2, "0");
  const digits = String(phone).replace(/\D/g, "");
  const firstName = String(name)
    .trim()
    .split(/\s+/)[0]
    .normalize("NFD")
    .replace(/[^A-Za-z]/g, "")
    .toUpperCase();
  const end =
    digits.length >= 4
      ? digits.slice(-4)
      : firstName || String(Math.floor(1000 + Math.random() * 9000));
  return `AMN-${p(d.getDate())}${p(d.getMonth() + 1)}-${p(d.getHours())}${p(d.getMinutes())}-${end}`;
};

/**
 * Monta a mensagem formatada para o WhatsApp.
 * A 1ª linha é o que aparece na lista de conversas: área, cidade/unidade e se é caso novo.
 */
export const waLink = (solution, extra = null) => {
  if (!extra) return `https://api.whatsapp.com/send?phone=${OFFICE.whatsapp}&text=${encodeURIComponent(waMessage(solution))}`;

  const areaName = (extra.area || solution || "Consulta jurídica").replace(/^Direito (do |de )?/i, "");
  const head = [
    extra.urgent ? "⚠️ *URGENTE*" : null,
    `⚖️ *${areaName.toUpperCase()}*`,
    extra.place ? `📍 ${clean(extra.place)}` : null,
    extra.status || null,
  ]
    .filter(Boolean)
    .join(" · ");

  const topic = solution && solution !== extra.area ? ` sobre *${clean(solution)}*` : "";
  const hello = extra.name
    ? `Olá! Meu nome é ${clean(extra.name)} e gostaria de agendar uma consulta${topic}.`
    : `Olá! Gostaria de agendar uma consulta${topic}.`;

  const line = ([k, v]) => `▪️ *${k}:* ${clean(v)}`;
  const block = (title, rows) => (rows.length ? `\n\n${title}\n${rows.map(line).join("\n")}` : "");

  const contact = [
    ["Nome", extra.name || "Não informado"],
    ["WhatsApp/Telefone", extra.phone || "Não informado"],
    ...(extra.contact || []).filter(([k]) => k !== "Já é cliente"),
  ];

  let msg = `${head}\n🔖 Protocolo: *${makeProtocol(extra)}*\n\n${hello}`;
  (extra.reasons || []).forEach((r) => (msg += `\n\n🚨 ${r}`));
  msg += block("📋 *TRIAGEM*", extra.triage || []);
  msg += block("👤 *DADOS PARA RETORNO*", contact);
  if (extra.summary) msg += `\n\n💬 *RESUMO DO CASO*\n${clean(extra.summary)}`;

  return `https://api.whatsapp.com/send?phone=${OFFICE.whatsapp}&text=${encodeURIComponent(msg)}`;
};

export const TEAM = [
  {
    name: "Maria Angélica da Silva Melo",
    oab: "OAB/MG 213.499",
    short:
      "Graduada em Direito pela Universidade José do Rosário Vellano (2002), pós-graduada em Direito Ambiental e Direito Digital. Aposentada da Polícia Civil de Minas Gerais, mantém-se em constante atualização jurídica.",
    mission:
      "Promover a justiça, a igualdade social e a defesa dos mais vulneráveis, conduzindo cada causa com empatia, responsabilidade e respeito às garantias fundamentais.",
    instagram: "@angelicameloadv",
    photo: "/adv-maria-angelica-v2.jpg",
  },
  {
    name: "Bárbara Negrini",
    oab: "OAB/MG 198.660 · OAB/SP 458.286",
    short:
      "Advogada e professora. Mestre em Gestão Pública e Sociedade pela UNIFAL/MG, graduada em Direito e pós-graduada em Direito Público pela PUC/MG.",
    mission:
      "Especialista em Direito Processual Civil, Direito Bancário, Políticas Públicas e Democracia — une conhecimento teórico e prática jurídica responsável, com ética e foco em resultados justos.",
    instagram: "@barbaranegrini.adv",
    photo: "/adv-barbara-v3.jpg",
  },
  {
    name: "Elizângela Amaral",
    oab: "OAB/MG 233.902",
    short:
      "27 anos na Polícia Civil de MG (26 em Poços de Caldas). Graduada em Direito pela Faculdade Alzira Velano (2002), aprovada no Exame da OAB n.º 39 (2023).",
    mission:
      "Pós-graduada em Direito Tributário pela Escola Mineira de Direito, em especialização em Agronegócio (EBPós) e capacitada em Direito Bancário e Execuções Judiciais e Extrajudiciais.",
    instagram: "@elizangela.amarall",
    photo: "/adv-elizangela-v2.jpg",
  },
];

import {
  ShieldAlert,
  HeartHandshake,
  Briefcase,
  Building2,
  Landmark,
  Plane,
  CreditCard,
  PackageSearch,
  Smartphone,
  Ban,
  HeartPulse,
  FileSignature,
  Scale,
  Users,
  HandCoins,
  ScrollText,
  ReceiptText,
  Link2,
  FileX2,
  KeyRound,
  Hourglass,
  Home,
  Stamp,
  CalendarClock,
  UserCheck,
  Accessibility,
  PiggyBank,
  History,
} from "lucide-react";

export const CATEGORIES = [
  {
    slug: "consumidor",
    label: "Direito do Consumidor",
    icon: ShieldAlert,
    tagline:
      "Quando uma empresa não cumpre o combinado, a lei está do seu lado — e nós sabemos como usá-la.",
    solutions: [
      {
        title: "Atraso ou Cancelamento de Voo",
        desc: "Atrasos acima de 4 horas, cancelamentos e overbooking geram direito a indenização e assistência imediata.",
        icon: Plane,
      },
      {
        title: "Cobrança Indevida no Cartão",
        desc: "Compras que você não reconheceu, juros abusivos e tarifas cobradas sem transparência podem ser revertidos.",
        icon: CreditCard,
      },
      {
        title: "Empréstimo Consignado Não Contratado",
        desc: "Descontos no benefício do INSS por empréstimo, cartão consignado (RMC/RCC) ou seguro que você não contratou podem ser questionados para suspender os descontos e buscar a devolução.",
        icon: ReceiptText,
      },
      {
        title: "Produto com Defeito (Vício do Produto)",
        desc: "Produto que estraga logo após a compra e loja que não troca: o Código de Defesa do Consumidor garante seus direitos.",
        icon: PackageSearch,
      },
      {
        title: "Golpes e Compras Online",
        desc: "Ficou no prejuízo após uma compra na internet? Há como rastrear, responsabilizar e reaver o valor pago.",
        icon: Smartphone,
      },
      {
        title: "Negativação Indevida",
        desc: "Nome sujo por dívida que não é sua? A exclusão do cadastro e uma possível indenização por dano moral são cabíveis.",
        icon: Ban,
      },
      {
        title: "Plano de Saúde — Negativa de Cobertura",
        desc: "Negação de exames, cirurgias ou medicamentos previstos no contrato pode ser revertida em caráter de urgência.",
        icon: HeartPulse,
      },
    ],
  },
  {
    slug: "familia",
    label: "Direito de Família",
    icon: HeartHandshake,
    tagline:
      "Momentos delicados pedem condução técnica e humana: protegemos os seus vínculos e o seu patrimônio.",
    solutions: [
      {
        title: "Divórcio e Partilha de Bens",
        desc: "Separação consensual ou litigiosa, com partilha justa, sigilo e o mínimo de desgaste possível.",
        icon: FileSignature,
      },
      {
        title: "Guarda e Convivência Familiar",
        desc: "Definição da guarda, do regime de convivência e do convívio com avós, sempre pelo melhor interesse da criança.",
        icon: Users,
      },
      {
        title: "Pensão Alimentícia",
        desc: "Fixação, revisão para mais ou para menos, e cobrança eficaz de parcelas atrasadas.",
        icon: HandCoins,
      },
      {
        title: "Inventário e Herança",
        desc: "Abertura e condução do inventário, judicial ou em cartório, com partilha transparente entre herdeiros.",
        icon: ScrollText,
      },
      {
        title: "União Estável",
        desc: "Reconhecimento ou dissolução da união estável, com garantia dos mesmos direitos do casamento.",
        icon: Link2,
      },
    ],
  },
  {
    slug: "trabalhista",
    label: "Direito Trabalhista",
    icon: Briefcase,
    tagline:
      "Da contratação à rescisão, todo trabalhador tem direitos. Verificamos se todos foram honrados.",
    solutions: [
      {
        title: "Verbas Rescisórias",
        desc: "Cálculo e cobrança de saldos devidos na demissão: aviso prévio, férias, 13º e multas do FGTS.",
        icon: Scale,
      },
      {
        title: "Assédio Moral no Trabalho",
        desc: "Constrangimento repetido, humilhações e perseguição geram direito a reparação. Orientamos como provar.",
        icon: FileX2,
      },
      {
        title: "Horas Extras não Pagas",
        desc: "Jornada além do contrato, banco de horas irregular e intervalos suprimidos podem — e devem — ser remunerados.",
        icon: Hourglass,
      },
      {
        title: "Reconhecimento de Vínculo",
        desc: "Trabalho sem carteira assinada? É possível reconhecer o vínculo e garantir todos os direitos da CLT.",
        icon: UserCheck,
      },
      {
        title: "Assessoria para Empresas",
        desc: "Para empregadores: defesa em ações trabalhistas, rescisões, contratos e orientação preventiva para evitar passivos.",
        icon: Building2,
      },
    ],
  },
  {
    slug: "imobiliario",
    label: "Direito Imobiliário",
    icon: Building2,
    tagline:
      "Do contrato de aluguel à entrega das chaves: blindamos o seu patrimônio imobiliário.",
    solutions: [
      {
        title: "Revisão de Contratos de Aluguel",
        desc: "Cláusulas abusivas, reajustes fora da lei e garantias exigidas além do permitido merecem revisão técnica.",
        icon: KeyRound,
      },
      {
        title: "Atraso na Entrega do Imóvel",
        desc: "Obra atrasada ou acabamento irregular na entrega? O comprador tem direito a multa e indenização.",
        icon: Hourglass,
      },
      {
        title: "Ação de Despejo",
        desc: "Representamos locadores e locatários em ações de despejo, com condução rápida e legalmente segura.",
        icon: Home,
      },
      {
        title: "Usucapião e Regularização",
        desc: "Imóvel ocupado por anos sem escritura? O usucapião transforma a posse em propriedade definitiva.",
        icon: Stamp,
      },
    ],
  },
  {
    slug: "previdenciario",
    label: "Direito Previdenciário",
    icon: Landmark,
    tagline:
      "A aposentadoria é um direito conquistado. Planejamos e defendemos o seu benefício no INSS.",
    solutions: [
      {
        title: "Planejamento de Aposentadoria",
        desc: "Análise do seu CNIS e simulação de cenários para você se aposentar na melhor regra e no melhor momento.",
        icon: CalendarClock,
      },
      {
        title: "Negativa de Benefício pelo INSS",
        desc: "Pedido negado ou concedido com valor errado? Recorremos e levamos o caso à Justiça quando necessário.",
        icon: FileX2,
      },
      {
        title: "Auxílio-doença e Invalidez",
        desc: "Afastamento por doença ou incapacidade: reunimos a documentação e acompanhamos perícia e recurso.",
        icon: HeartPulse,
      },
      {
        title: "BPC / LOAS",
        desc: "Benefício de um salário mínimo para idosos e pessoas com deficiência de baixa renda, mesmo sem contribuição ao INSS.",
        icon: Accessibility,
      },
      {
        title: "Revisão de Benefício",
        desc: "Benefício antigo calculado com erro? Revisões retroativas podem recuperar valores por até 5 anos.",
        icon: PiggyBank,
      },
      {
        title: "Recolhimentos em Atraso",
        desc: "Autônomos e contribuintes individuais: regularizamos contribuições passadas sem comprometer sua aposentadoria.",
        icon: History,
      },
    ],
  },
];
